import { ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const headerStyles = xcss({
  font: 'font.heading.xxsmall',
  fontWeight: 'font.weight.heading',
  color: 'color.text.subtle',
});

type TableHeaderProps = {
  children: ReactNode;
};

export const TestTableHeader = ({ children }: TableHeaderProps) => (
  <Box xcss={headerStyles}>{children}</Box>
);
